import type { StatusDelivery } from '@/Interfaces/Data';
import {
  MONITOR_CURRENT_STEP_FALLBACK_LABEL,
  MONITOR_CURRENT_STEP_LABEL,
} from '../../../../constants';
import type { MonitorDeliveryDetailMetrics } from '../../../../types';
import { formatElapsedTime } from '../../../../utils';
import { ElapsedTime } from '../../../elapsed-time/elapsed-time';
import { MetricTile } from './components/metric-tile/metric-tile';
import { MetricValue } from './components/metric-value/metric-value';
import styles from './delivery-metrics.module.scss';

const EMPTY_VALUE = '—';

interface DeliveryMetricsProps {
  status: StatusDelivery;
  metrics: MonitorDeliveryDetailMetrics;
}

export function DeliveryMetrics({ status, metrics }: DeliveryMetricsProps) {
  const { elapsedMinutes, slaLevel, currentStepMinutes, totalDistanceKm } =
    metrics;

  return (
    <div className={styles.tiles}>
      <MetricTile label="Decorrido">
        <ElapsedTime elapsedMinutes={elapsedMinutes} slaLevel={slaLevel} />
      </MetricTile>
      <MetricTile
        label={
          MONITOR_CURRENT_STEP_LABEL[status] ??
          MONITOR_CURRENT_STEP_FALLBACK_LABEL
        }
      >
        <MetricValue>
          {currentStepMinutes === null
            ? EMPTY_VALUE
            : formatElapsedTime(currentStepMinutes)}
        </MetricValue>
      </MetricTile>
      <MetricTile label="Distância">
        <MetricValue>
          {totalDistanceKm === null
            ? EMPTY_VALUE
            : `${totalDistanceKm.toFixed(1)} km`}
        </MetricValue>
      </MetricTile>
    </div>
  );
}
